import { remove } from "lodash";

import categoryService from "app/common/services/categoryService";
import { i18nFilter } from "app/filters/i18nFilter";
import { categoryClassIconFilter } from "app/filters/ngFilters";
import CountryService from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import { RankByMode } from "app/pages/website-analysis/TrafficAndEngagement/types";

import { FlexWrapper, StyledLinkWrapper, Text } from "../../StyledComponents";

interface IWebsiteRankSubtitleFiltersParams {
    data?: unknown;
    selectedRankByMode: RankByMode;
    subtitleFilters: Array<Record<string, unknown>>;
    defaultCountry: string;
    getRedirectUrl: (country: string, category: string) => string;
}

export const getWebsiteRankSubtitleFilters = ({
    data,
    selectedRankByMode,
    subtitleFilters,
    defaultCountry,
    getRedirectUrl,
}: IWebsiteRankSubtitleFiltersParams): Array<Record<string, unknown>> => {
    if (!data) {
        return subtitleFilters;
    }

    if (selectedRankByMode === RankByMode.Global) {
        const globalFilters = [...subtitleFilters];
        remove(globalFilters, (filterObj) => filterObj?.filter === "country");

        globalFilters.push({
            filter: "country",
            countryCode: WORLDWIDE_COUNTRY_ID,
            value: CountryService.getCountryById(WORLDWIDE_COUNTRY_ID)?.text,
        });

        return globalFilters;
    }

    const header = ((data as { Header?: Record<string, string> })?.Header ?? {}) as Record<string, string>;
    const category = header.category ?? "";
    const rankCountry = header.country ?? "";

    if (selectedRankByMode === RankByMode.Industry && category) {
        const categories = categoryService.getFlattenedCategoriesList();
        const selectedCategory = categories.find(({ forApi }) => forApi.substring(1) === category);

        if (!selectedCategory) {
            return subtitleFilters;
        }

        const categoryRedirectUrl = getRedirectUrl(defaultCountry, selectedCategory.id);

        const dateFilter = subtitleFilters.find((filterObj) => filterObj?.filter === "date");
        const countryFilter = subtitleFilters.find((filterObj) => filterObj?.filter === "country");

        return [
            ...(dateFilter ? [dateFilter] : []),
            ...(countryFilter ? [countryFilter] : []),
            {
                value: () => {
                    return (
                        <StyledLinkWrapper url={categoryRedirectUrl}>
                            <FlexWrapper>
                                <Text rightMargin={3}>
                                    {i18nFilter()("workspace.sales.benchmarks.toolbar.dropdown.countries.prefix")}
                                </Text>
                                <span>
                                    <i
                                        className={`sprite-category u-right-padding-6 ${categoryClassIconFilter()(
                                            selectedCategory.id,
                                        )}`}
                                    />
                                </span>
                                <Text>{i18nFilter()("common.category." + category.toLowerCase())}</Text>
                            </FlexWrapper>
                        </StyledLinkWrapper>
                    );
                },
            },
        ];
    }

    const subtitleFiltersForMerge = [...subtitleFilters];
    remove(subtitleFiltersForMerge, (filterObj) => filterObj?.filter === "country");

    subtitleFiltersForMerge.push({
        filter: "country",
        countryCode: rankCountry,
        value: CountryService.getCountryById(rankCountry)?.text,
        href: getRedirectUrl(rankCountry, "All"),
    });

    return subtitleFiltersForMerge;
};
